module.exports = __webpack_public_path__ + "img/yzappfw1.9a88557e.png";